// extracted by mini-css-extract-plugin
module.exports = {"prizes-tooltip":"_30kx38","bonuses":"_3XjVwX","points":"AcQYQx"};